import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};
// statecode asc,
const skillSetMasterService = {
  fetchAllSkills: () => {
    return axiosInstance.get(
      "/itl_skillsetmasters?$select=itl_skillsetmasterid,itl_name,statecode&$orderby=createdon desc",
      {
        headers: headers,
      }
    );
  },

  fetchAllActiveSkills: () => {
    return axiosInstance.get(
      "/itl_skillsetmasters?$select=itl_skillsetmasterid,itl_name&$filter=statecode eq 0&$orderby=statecode asc,createdon desc",
      {
        headers: headers,
      }
    );
  },

  addNewSkill: (obj) => {
    return axiosInstance.post("/itl_skillsetmasters", obj, {
      headers: headers,
    });
  },

  updateSkill: (id, obj) => {
    return axiosInstance.patch(`/itl_skillsetmasters(${id})`, obj, {
      headers: headers,
    });
  },
};

export default skillSetMasterService;
